// TODO: Add Types
'use es6';

import { List } from 'immutable';
import I18n from 'I18n';
import FormattedMessage from 'I18n/components/FormattedMessage';
import Small from 'UIComponents/elements/Small';
import { DEAL } from 'customer-data-objects/constants/ObjectTypes';
import { getProperty } from 'customer-data-objects/model/ImmutableModel';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function isQuoteExpired(quote) {
  const expiresAt = parseInt(getProperty(quote, 'hs_expiration_date'), 10);
  return expiresAt ? I18n.moment().isAfter(expiresAt) : false;
}
function isQuoteArchived(quote) {
  const isArchived = getProperty(quote, 'hs_archived');
  return isArchived === true || isArchived === 'true';
}
function isQuotePublished(quote) {
  return !!getProperty(quote, 'hs_quote_link');
}
function getQuoteSelectText(quote) {
  const createdAt = parseInt(getProperty(quote, 'hs_createdate') || 0, 10);
  const date = I18n.moment.userTz(createdAt).format('lll');
  const title = getProperty(quote, 'hs_title');
  const formattedQuoteName = isQuoteExpired(quote) ? /*#__PURE__*/_jsx(FormattedMessage, {
    message: "customerDataContent.QuotesSelect.expiredQuote",
    options: {
      quoteTitle: title
    }
  }) : title;
  return /*#__PURE__*/_jsxs("div", {
    children: [/*#__PURE__*/_jsx(Text, {
      paddingBlockEnd: "0",
      marginBlockEnd: "0",
      as: "p",
      children: formattedQuoteName
    }), /*#__PURE__*/_jsx(Small, {
      className: "truncate-text",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "customerDataContent.QuotesSelect.generatedOn",
        options: {
          date
        }
      })
    })]
  });
}
function getQuoteSelectValue(quote) {
  return getProperty(quote, 'hs_quote_link');
}
export function getSelectableQuotes({
  objectType,
  quotes
}) {
  const selectableQuotes = quotes.filter(quote => {
    return !!getProperty(quote, 'hs_deal_name') && isQuotePublished(quote) && !isQuoteArchived(quote);
  }).sortBy(quote => getProperty(quote, 'hs_createdate'), (a, b) => parseInt(b || 0, 10) - parseInt(a || 0, 10));
  if (objectType === DEAL) {
    return selectableQuotes.map(quote => {
      return {
        text: getQuoteSelectText(quote),
        value: getQuoteSelectValue(quote),
        title: getProperty(quote, 'hs_title')
      };
    }).toArray();
  }
  const groupedQuotes = selectableQuotes.groupBy(quote => getProperty(quote, 'hs_deal_name'));
  return groupedQuotes.reduce((options, quotesOnDeal, dealName) => {
    return options.push({
      text: dealName,
      options: quotesOnDeal.map(quote => {
        return {
          text: getQuoteSelectText(quote),
          value: getQuoteSelectValue(quote),
          title: getProperty(quote, 'hs_title')
        };
      }).toArray()
    });
  }, List()).toArray();
}